import { render } from "./SpeechBubble.vue?vue&type=template&id=5434e4da"
import script from "./SpeechBubble.vue?vue&type=script&lang=js"
export * from "./SpeechBubble.vue?vue&type=script&lang=js"

import "./SpeechBubble.vue?vue&type=style&index=0&id=5434e4da&lang=css"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__